module.exports = __webpack_public_path__ + "img/code-reviewer.ff94dc1b.webp";